import React, { useEffect, useState, useRef } from "react";
import "../../../StyleSheet/MainComponent/LoginPage/LoginPage.scss";
import Email from "../../AppComponent/InputFields/Email";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import Password from "../../AppComponent/InputFields/Password";
import RefreshIcon from "@mui/icons-material/Refresh";
import validator from "validator";
import { useDispatch, useSelector } from "react-redux";
import { getUserAction, setLaguage, settheCustomerUDSemployeeloginresponse } from "../../../Redux/Slice";
import logo from "../../../Assets/AppComponent/Logo/Group 56.png";
import toppart from "../../../Assets/AppComponent/TopPartImg/Vector.png";
import Arrow from "../../../Assets/AppComponent/Arrow/Frame.png";
import worldimg from "../../../Assets/AppComponent/WorldImgs/Layer_1.png";
import Select from "react-dropdown-select";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import gif from "../../../Assets/loader.gif";
import { setTheIdOne, setTheUDSTOKEN } from "../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import config from "../../../Redux/Config"; // Use this line if using configuration file

const LoginPage = (props) => {
  const { languageOptions, Lang, setLang } = props;

  const state = useSelector((state) => state);

  const EnglishData = data;
  const HindiData = hindiDatas;
  const Datas = {
    email: "",
    Password: "",
  };
  const [InputData, setInputDatas] = useState(Datas);
  const [EmailError, setEmailError] = useState("");
  const [PasswordError, setPasswordError] = useState("");
  const [isvalid, setvalid] = useState(true);
  const [validateType, setValidatetype] = useState(null);
  const [UDSTOKEN, setUDSTOken] = useState(null);
  const navigate = useNavigate();

  const Navigate = useNavigate();

  const [captchaText, setCaptchaText] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const canvasRef = useRef(null);

  const generateNewCaptcha = (keepError = false) => {
    const chars = "23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars[Math.floor(Math.random() * chars.length)];
    }
    setCaptchaText(result);
    setCaptchaInput("");
    if (!keepError) {
      setCaptchaError("");
    }
  };

  const generateCaptchaCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#f4f6f9";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    for (let i = 0; i < 6; i++) {
      ctx.strokeStyle = `rgba(${Math.floor(Math.random() * 150)}, ${Math.floor(Math.random() * 150)}, ${Math.floor(Math.random() * 150)}, 0.3)`;
      ctx.lineWidth = 1.5;
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.stroke();
    }

    ctx.font = "bold 28px Arial, Helvetica, sans-serif";
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";

    const step = canvas.width / (captchaText.length + 1);
    for (let i = 0; i < captchaText.length; i++) {
      const char = captchaText[i];
      ctx.fillStyle = `rgb(${Math.floor(Math.random() * 90)}, ${Math.floor(Math.random() * 90)}, ${Math.floor(Math.random() * 90)})`;

      const x = step * (i + 1);
      const y = canvas.height / 2 + (Math.random() * 6 - 3);
      const angle = (Math.random() * 20 - 10) * Math.PI / 180;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(char, 0, 0);
      ctx.restore();
    }

    for (let i = 0; i < 35; i++) {
      ctx.fillStyle = `rgba(${Math.floor(Math.random() * 200)}, ${Math.floor(Math.random() * 200)}, ${Math.floor(Math.random() * 200)}, 0.4)`;
      ctx.beginPath();
      ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1 + Math.random() * 1.5, 0, Math.PI * 2);
      ctx.fill();
    }
  };

  useEffect(() => {
    if (captchaText) {
      generateCaptchaCanvas();
    }
  }, [captchaText, Lang]);

  useEffect(() => {
    generateNewCaptcha();
  }, []);



  // const [Lang, setLang] = useState(1)
  const HandleChanges = (e) => {
    setInputDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };
  const dispatch = useDispatch();
  const validate = () => {
    const numericvalue = InputData.email.replace(/\D/g, "");
    if (!isNaN(numericvalue) && numericvalue.length === 10) {
      setvalid(true);
      setValidatetype("phone number");
    } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(InputData.email)) {
      setvalid(true);
      setValidatetype("email");
    } else {
      setvalid(false);
      setValidatetype(null);
    }
  };
  const requiredVersion = config.requiredVersion; // For configuration file


  useEffect(() => {
    if (localStorage.getItem("websiteversion") == null) {
      localStorage.clear();
      navigate("/");
      dispatch(setTheUDSTOKEN(""));
      localStorage.setItem("websiteversion", requiredVersion);
      console.log("version", 1);
    } else if (
      localStorage.getItem("websiteversion") == requiredVersion
    ) {
      console.log(
        "version",
        requiredVersion,
        localStorage.getItem("websiteversion")
      );
    } else {
      localStorage.clear();
      navigate("/");
      dispatch(setTheUDSTOKEN(""));
      console.log("version", 3);
    }
  }, []);

  const handleSubmit = () => {
    var a = 0;
    // ErrorEmail(a)
    // Passworderror(a)
    localStorage.clear();
    console.log(captchaInput, "captchaInput")
    if (!validator.isEmail(InputData.email)) {
      setEmailError("*Enter valid mail id");
      a = 1;
    }

    var reg =
      "^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[d]){1,})(?=(.*[W]){1,})(?!.*s).{8,}$";
    if (validator.isEmpty(InputData.Password)) {
      setPasswordError("*password is required");
      a = 1;
    }

    if (!captchaInput.trim()) {
      setCaptchaError("*Please enter captcha");
      a = 1;
    } else if (captchaInput.trim() !== captchaText) {
      generateNewCaptcha(true);
      setCaptchaError("*Please enter valid captcha");
      a = 1;
    }

    // if (InputData.Password.length < 10) {
    //     setPasswordError("*enter valid password")
    //     a = 1;
    // }

    if (a == 0) {
      const payload = {
        data: InputData,
        Funcations: () => {
          // Your function logic here
          console.log('Function called');
          if (InputData.email == "hdfcsales@uds.in" || InputData.email == "sbilife@uds.in" || InputData.email == "arcolab@uds.in") {
            Navigate("/advance_new_attendance")
          } else {
            Navigate("/")
          }
        },
      }
      dispatch(getUserAction(payload));
      generateNewCaptcha();
    }
  };
  const HandleSubmits = (event) => {
    event.preventDefault();
  };
  //-----------------Language---Options---
  useEffect(() => {
    dispatch(setLaguage("English"));
  }, []);
  const LanguageChange = (e) => {
    console.log(e.target.value, "values");
    props.onChange(e);

    dispatch(setLaguage(e.target.value));
    // if (e.target.value == "English") {
    //     setLang(1)
    // }
    // else {
    //     setLang(0)
    // }
  };
  //--------____Forgot------------_Password-----------
  const handleClick = () => {
    // window.location.href = "/forgotpassword";
    Navigate("/forgotpassword")
  };
  const HandleSubmit = (e) => {
    e.preventDefault();
  };

  // setInterval(() => {
  //   dispatch(setTheIdOne(3));
  // }, 6900);

  return (
    <>
      <div className="uds-loginpage ">
        <div className="  Conatiningpart">
          <div className="Welcomepart">
            <div className="Toppart">
              <img className="desingimg" src={toppart} />
            </div>
            <div className="bottompart">
              <div className="leftSidepart">
                <div className="Logo">
                  <img className="logoUds" src={logo} />
                </div>
                {Lang == 1 ? (
                  <>
                    {EnglishData.LeftSide.Welcome.map((item) => (
                      <div className="Content" id={item.id}>
                        <h1>{item.Heading}</h1>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {HindiData.LeftSide.Welcome.map((item) => (
                      <div className="Content" id={item.id}>
                        <h1>{item.Heading}</h1>
                      </div>
                    ))}
                  </>
                )}
                {Lang == 1 ? (
                  <>
                    {EnglishData.LeftSide.Content.Content.map((item) => (
                      <p>{item.para1}</p>
                    ))}
                  </>
                ) : (
                  <>
                    {HindiData.LeftSide.Content.Content.map((item) => (
                      <p>{item.para1}</p>
                    ))}
                  </>
                )}


              </div>
            </div>
          </div>
          <div className=" loginpart">
            <div className="Loginwrapped">
              <div className="Udslog">
                {Lang == 1 ? (
                  <>
                    {EnglishData.LeftSide.LoginPages.map((item) => (
                      <h4 className="heading" key={item.id}>
                        {item.LoginHead}
                      </h4>
                    ))}
                  </>
                ) : (
                  <>
                    {HindiData.LeftSide.LoginPages.map((item) => (
                      <h4 className="heading" key={item.id}>
                        {item.LoginHead}
                      </h4>
                    ))}
                  </>
                )}

                <form onSubmit={HandleSubmit} autoComplete="on">
                  <div className="Input-Inner">
                    {Lang == 1 ? (
                      <>
                        {EnglishData.LeftSide.InputLabel.map((item) => (
                          <React.Fragment key={item.id}>
                            <Email
                              value={InputData.email}
                              onChange={(e) => {
                                setEmailError("");
                                HandleChanges(e);
                              }}
                              Error={EmailError}
                              label={item.labelEm}
                              type={"text"}
                              isvalid={isvalid}
                              validateType={validateType}
                            />
                            <Password
                              value={InputData.Password}
                              onChange={(e) => {
                                setPasswordError("");
                                HandleChanges(e);
                              }}
                              Error={PasswordError}
                              label={item.labelPas}
                              autoCompleted={"current-password"}
                            />
                            <div className="Outer-Inputs captcha-outer">
                              <label style={{ fontWeight: "900" }}>{item.labelCaptcha}</label>
                              <div className="captcha-display-row">
                                <canvas
                                  width="240"
                                  height="48"
                                  ref={canvasRef}
                                  className="captcha-canvas"
                                />
                                <button
                                  type="button"
                                  onClick={() => generateNewCaptcha()}
                                  className="captcha-refresh-btn"
                                  title="Refresh CAPTCHA"
                                >
                                  <RefreshIcon />
                                </button>
                              </div>
                              <div className="Email inputFields captcha-input-field">
                                <input
                                  type="text"
                                  value={captchaInput}
                                  onChange={(e) => {
                                    setCaptchaError("");
                                    setCaptchaInput(e.target.value);
                                  }}
                                  placeholder={item.labelCaptcha}
                                  autoComplete="off"
                                />
                              </div>
                              {captchaError && (
                                <p style={{ color: "red", paddingLeft: "28px" }} className="Errors_list">
                                  {captchaError}
                                </p>
                              )}
                            </div>
                          </React.Fragment>
                        ))}
                      </>
                    ) : (
                      <>
                        {HindiData.LeftSide.InputLabel.map((item) => (
                          <React.Fragment key={item.id}>
                            <Email
                              value={InputData.email}
                              onChange={(e) => {
                                setEmailError("");
                                HandleChanges(e);
                              }}
                              Error={EmailError}
                              label={item.labelEm}
                              type={"text"}
                              isvalid={isvalid}
                              validateType={validateType}
                            />
                            <Password
                              value={InputData.Password}
                              onChange={(e) => {
                                setPasswordError("");
                                HandleChanges(e);
                              }}
                              Error={PasswordError}
                              label={item.labelPas}
                              autoCompleted={"current-password"}
                            />
                            <div className="Outer-Inputs captcha-outer">
                              <label style={{ fontWeight: "900" }}>{item.labelCaptcha}</label>
                              <div className="captcha-display-row">
                                <canvas
                                  width="240"
                                  height="48"
                                  ref={canvasRef}
                                  className="captcha-canvas"
                                />
                                <button
                                  type="button"
                                  onClick={() => generateNewCaptcha()}
                                  className="captcha-refresh-btn"
                                  title="Refresh CAPTCHA"
                                >
                                  <RefreshIcon />
                                </button>
                              </div>
                              <div className="Email inputFields captcha-input-field">
                                <input
                                  type="text"
                                  value={captchaInput}
                                  onChange={(e) => {
                                    setCaptchaError("");
                                    setCaptchaInput(e.target.value);
                                  }}
                                  placeholder={item.labelCaptcha}
                                  autoComplete="off"
                                />
                              </div>
                              {captchaError && (
                                <p style={{ color: "red", paddingLeft: "28px" }} className="Errors_list">
                                  {captchaError}
                                </p>
                              )}
                            </div>
                          </React.Fragment>
                        ))}
                      </>
                    )}
                  </div>
                  <div className="SubmitButton">
                    {Lang == 1 ? (
                      <>
                        {EnglishData.LeftSide.Button.Button1.map((item) => (
                          <CustomButton
                            key={item.id}
                            children="Submit"
                            onClick={handleSubmit}
                            type={"submit"}
                            className="ButtonCSS"
                          disabled={captchaInput.length === 0}
                          >
                            {item.ButtonName}
                          </CustomButton>
                        ))}
                      </>
                    ) : (
                      <>
                        {HindiData.LeftSide.Button.Button1.map((item) => (
                          <CustomButton
                            key={item.id}
                            children="Submit"
                            onClick={handleSubmit}
                            type={"submit"}
                            className="ButtonCSS"
                            disabled={captchaInput.length === 0}
                          >
                            {item.ButtonName}
                          </CustomButton>
                        ))}
                      </>
                    )}
                  </div>


                  <div className="FortgotPassword" onClick={handleClick}>
                    {Lang == 1 ? (
                      <>
                        {EnglishData.LeftSide.ForgotPassword.map((item) => (
                          <p>{item.Forgot}</p>
                        ))}
                      </>
                    ) : (
                      <>
                        {HindiData.LeftSide.ForgotPassword.map((item) => (
                          <p>{item.Forgot}</p>
                        ))}
                      </>
                    )}
                  </div>

                </form>
              </div>


            </div>



          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
